// The fields a leave template asks for. The values typed so far, the check before sending and the
// payload are the document form's own (build-pdf-utils), so a request made here is the same as one
// made in the leave calendar.
import { isCustomFieldShown, validateForm, type ValidationError } from "components/customer/build-pdf/build-pdf-utils";
import type { CustomField } from "types/CustomField";

/** The field types this sheet can show. A required field of any other type (a file, a product list...) cannot be filled in here. */
const FILLABLE_TYPES: CustomField["type"][] = ["string", "textarea", "number", "date", "select", "user", "signature"];

/** The template's fields with the values typed so far (by field label); an untouched field is empty, a file field an empty list. */
export function fieldsWithValues(templateFields: CustomField[], typed: Record<string, string>): CustomField[] {
  return templateFields.map((field) => ({
    ...field,
    options: field.options ?? [],
    value: typed[field.label] ?? (field.type === "file" ? [] : ""),
  }));
}

export function isFillable(field: CustomField): boolean {
  return FILLABLE_TYPES.includes(field.type);
}

/** True when a field that must be filled in cannot be shown here. */
export function hasUnfillableRequiredField(fields: CustomField[]): boolean {
  return fields.some((field) => field.required && !isFillable(field) && isCustomFieldShown(field, fields));
}

/** What is wrong with the fields, by field label: a missing required value, a value shorter than `minLength`... */
export function fieldErrors(templateId: string, date: string, fields: CustomField[]): Record<string, ValidationError> {
  return validateForm({
    templateId,
    date,
    subject: "user",
    selectedContactIds: [],
    signType: "",
    selectedUser: "",
    selectedNonTechUser: "",
    isSystemSource: false,
    isEditingSystemTemplate: false,
    isAutoBusinessTripDocument: false,
    customFields: fields,
    products: [],
    productGroups: [],
  });
}
